import moment from 'moment-timezone';
import { SpacesState, SpacesActionTypes } from '../types/spaces';
import { ImplementedState, ImplementedActionTypes } from '../types/implemented';
import { SenseiApi } from '../utils/api';
import { Space } from '../types/api';

import { getDefaultSortFunction } from '@densityco/ui';

// Fetch a list of one space and put it into the `SpacesStore`
export async function fetchSingleSpace(
  dispatch,
  state: SpacesState,
  jwtToken: string,
  spaceId: string,
) {
  dispatch({ type: SpacesActionTypes.SPACES_LOAD_START });

  let organizations, space: Space | undefined;
  try {
    [organizations, space] = await Promise.all([
      SenseiApi.organizationList(jwtToken),
      SenseiApi.spaceDetails(jwtToken, spaceId),
    ]);
  } catch (error) {
    dispatch({
      type: SpacesActionTypes.SPACES_LOAD_ERROR,
      error,
    });
    return;
  }

  dispatch({
    type: SpacesActionTypes.SPACES_LOAD_DETAIL_COMPLETE,
    space,
  });

  return space;
}

export async function fetchSingleSpaceMPIs(
  dispatch,
  space: {
    external_id: string;
    organization_external_id: string;
  },
  jwtToken: string,
) {
  dispatch({ type: SpacesActionTypes.SPACE_DETAIL_MPIS_LOAD_START });
  try {
    SenseiApi.multiPointInstallationList(jwtToken, {
      space_id: space.external_id,
      page_size: 50,
    }).then((response) => {
      dispatch({
        type: SpacesActionTypes.SPACE_DETAIL_MPIS_LOAD_COMPLETE,
        mpis: response.results,
      });
    });
  } catch (error) {
    dispatch({ type: SpacesActionTypes.SPACE_DETAIL_MPIS_LOAD_ERROR }, error);
  }
}

// Fetch a list of one space and put it into the `SpacesStore`
export async function fetchSingleSpaceCounts(
  dispatch,
  space: {
    external_id: string;
    organization_external_id: string;
    time_zone: string;
    daily_reset: string;
  },
  jwtToken: string,
  date: string,
) {
  dispatch({ type: SpacesActionTypes.SPACES_DETAIL_COUNTS_LOAD_START });

  // Calculate the start and end time for the counts query by adding the daily reset time to the
  // date passed in if it exists.
  const startTime = moment(date).add(
    space.daily_reset ? moment.duration(space.daily_reset) : 0,
  );
  const endTime = startTime.clone().add(1, 'day');

  let counts;
  try {
    counts = await SenseiApi.spaceCounts(
      jwtToken,
      space.external_id,
      space.organization_external_id,
      startTime.format('YYYY-MM-DDTHH:mm:ss'),
      endTime.format('YYYY-MM-DDTHH:mm:ss'),
    );
  } catch (error) {
    dispatch({
      type: SpacesActionTypes.SPACES_DETAIL_COUNTS_LOAD_ERROR,
      error,
    });
    return;
  }

  dispatch({
    type: SpacesActionTypes.SPACES_DETAIL_COUNTS_LOAD_COMPLETE,
    counts: counts.data[0].metrics.map((i) => ({
      timestamp: i.ts,
      bucketCount: i.occ_max_unbounded,
    })),
  });
}
